import { connect } from 'react-redux';

import Referrals from 'components/referrals';

import actions from 'redux/actions';

const mapStateToProps = (state: any) => {
    const { caseloads, isFetchingCaseloads } = state.homelesses;
    const {
        incomingReferrals,
        isFetchingIncomingReferrals,
        isFetchingOutgoingReferrals,
        outgoingReferrals,
        uniqueMemberInfo,
        incomingCareCoordinatorReferrals,
        outgoingCareCoordinatorReferrals,
        isFetchingIncomingCareCoordinatorReferrals,
        isFetchingOutgoingCareCoordinatorReferrals
    } = state.referrals;
    const { user } = state.user;

    return {
        caseloads,
        incomingReferrals,
        outgoingReferrals,
        incomingCareCoordinatorReferrals,
        outgoingCareCoordinatorReferrals,
        isFetchingCaseloads,
        isFetchingIncomingReferrals,
        isFetchingOutgoingReferrals,
        isFetchingIncomingCareCoordinatorReferrals,
        isFetchingOutgoingCareCoordinatorReferrals,
        uniqueMemberInfo,
        user
    };
};

const mapDispatchToProps = {
    acceptReferral: actions.acceptReferral,
    fetchCaseloads: actions.getCaseloads,
    fetchReferrals: actions.fetchUserReferralsRequest,
    fetchIncomingCareCoordinatorReferrals: actions.fetchIncomingCareCoordinatorReferralsRequest,
    fetchOutgoingCareCoordinatorReferrals: actions.fetchOutgoingCareCoordinatorReferralsRequest,
    rejectReferral: actions.rejectReferral,
    resetUserReferrals: actions.resetUserReferrals,
    removeMemberFromMyMembers: actions.removeMemberFromMyMembers,
    saveMemberToMyMembers: actions.saveMemberToMyMembers,
    setLayoutTitles: actions.setLayoutTitles
};

export default connect(mapStateToProps, mapDispatchToProps)(Referrals);
